// src/components/Footer.jsx
import React from "react";
import { Link } from 'react-router-dom';

import "@fortawesome/fontawesome-free/css/all.min.css"; // ensure the package is installed

export default function Footer({
  logoSrc = "./images/logo.png",
  brandName = "Aizen Architecture",
  email = "reservation@swamisamarthpg.com",
  phone = "+91 9209169761",
  // phone = "+91 9096665072",
  address = "Shree Swami Samarth PG M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057",
  social = {
    instagram: "#",
    facebook: "#",
    linkedin: "#",
    pinterest: "#",
    twitter: "#",
    youtube: "#",
  },
  year = new Date().getFullYear(),
}) {
  const socials = [
    { key: "instagram", icon: "fab fa-instagram" },
    { key: "facebook", icon: "fab fa-facebook-f" },
    { key: "linkedin", icon: "fab fa-linkedin" },
    { key: "pinterest", icon: "fab fa-pinterest" },
    { key: "twitter", icon: "fab fa-twitter" },
    { key: "youtube", icon: "fab fa-youtube" },
  ].filter((s) => social[s.key]);

  return (
    <footer className="main-footer">
      {/* Widgets Section */}
      <div className="widgets-section">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="column col-md-12 col-sm-12 col-xs-12">
              <div className="row clearfix">
                {/* Footer Column: Logo + About */}
               



   {/* Footer Column: Social */}
                <div className="footer-column col-md-4 col-sm-6 col-xs-12">
                  <div className="footer-widget logo-widget">
                    <div className="footer-title">
                      <h2>Our Services</h2>
                      <div className="separator"></div>
                    </div>
                    <div className="widget-content">
                     <Link className="mx-md-2 d-block" to="/PG-in-Pune"><i className="fa fa-bed darkcollor"></i> PG in Pune</Link>
<Link className="mx-md-2 d-block" to="/Single-Room-PG-in-Pune"><i className="fa fa-bed darkcollor"></i> Single Room PG in Pune</Link>
{/* <Link className="mx-md-2 d-block" to="/PG-in-Baner"><i className="fa fa-bed darkcollor"></i> PG in Baner</Link>
<Link className="mx-md-2 d-block" to="/Hostels-in-Baner"><i className="fa fa-bed darkcollor"></i> Hostels in Baner</Link>
<Link className="mx-md-2 d-block" to="/PG-in-Aundh-Baner"><i className="fa fa-bed darkcollor"></i> PG in Aundh Baner</Link>
<Link className="mx-md-2 d-block" to="/Paying-Guest-Hostel-in-Baner"><i className="fa fa-bed darkcollor"></i> Paying Guest Hostel in Baner</Link>
<Link className="mx-md-2 d-block" to="/Girls-Hostels-in-Baner"><i className="fa fa-bed darkcollor"></i> Girls Hostels in Baner</Link>
<Link className="mx-md-2 d-block" to="/Boys-Hostel-in-Baner"><i className="fa fa-bed darkcollor"></i> Boys Hostel in Baner</Link>
<Link className="mx-md-2 d-block" to="/Monthly-Basis-PG-in-Baner-Pune"><i className="fa fa-bed darkcollor"></i> Monthly Basis PG in Baner Pune</Link>
<Link className="mx-md-2 d-block" to="/PG-in-Baner-Balewadi"><i className="fa fa-bed darkcollor"></i> PG in Baner Balewadi</Link>
<Link className="mx-md-2 d-block" to="/PG-in-Baner-With-Food"><i className="fa fa-bed darkcollor"></i> PG in Baner With Food</Link>
<Link className="mx-md-2 d-block" to="/PG-for-Students-in-Baner-Pune"><i className="fa fa-bed darkcollor"></i> PG for Students in Baner Pune</Link>
<Link className="mx-md-2 d-block" to="/PG-for-Working-Professionals-Pune"><i className="fa fa-bed darkcollor"></i> PG for Working Professionals Pune</Link>
<Link className="mx-md-2 d-block" to="/Luxury-PG-in-Baner"><i className="fa fa-bed darkcollor"></i> Luxury PG in Baner</Link> */}
<Link className="mx-md-2 d-block" to="/Paying-Guest-Near-Hinjewadi-IT-Park-Pune"><i className="fa fa-bed darkcollor"></i> Paying Guest Near Hinjewadi IT Park Pune</Link>
<Link className="mx-md-2 d-block" to="/Hostel-in-Pune"><i className="fa fa-bed darkcollor"></i> Hostel in Pune</Link>
<Link className="mx-md-2 d-block" to="/Best-Luxury-PG-in-Pune"><i className="fa fa-bed darkcollor"></i> Best Luxury PG in Pune</Link>
                     <Link className="mx-md-2 d-block" to="/Best-PG-in-Hinjewadi-Phase-1-for-Females-with-Food-Near-Infosys"><i className="fa fa-bed darkcollor"></i> Best PG in Hinjewadi Phase 1 for Females with Food Near Infosys</Link>
<Link className="mx-md-2 d-block" to="/Best-PG-in-Hinjewadi-Phase-3-for-Working-Ladies"><i className="fa fa-bed darkcollor"></i> Best PG in Hinjewadi Phase 3 for Working Ladies</Link>
<Link className="mx-md-2 d-block" to="/Luxury-PG-in-Hinjewadi-Near-Blue-Ridge-and-Megapolis"><i className="fa fa-bed darkcollor"></i> Luxury PG in Hinjewadi Near Blue Ridge and Megapolis</Link>

                    </div>
                  </div>
                </div>

                         {/* Footer Column: Social */}
                <div className="footer-column col-md-4 col-sm-6 col-xs-12">
                  <div className="footer-widget logo-widget">
                    <div className="footer-title">
                      <h2>Our Services</h2>
                      <div className="separator"></div>
                    </div>
                    <div className="widget-content">
<Link className="mx-md-2 d-block" to="/Single-Sharing-PG-in-Hinjewadi-for-Male-and-Female"><i className="fa fa-bed darkcollor"></i> Single Sharing PG in Hinjewadi for Male & Female</Link>

<Link className="mx-md-2 d-block" to="/Couple-Friendly-PG-in-Hinjewadi-Phase-2-Near-Wipro"><i className="fa fa-bed darkcollor"></i> Couple Friendly PG in Hinjewadi Phase 2 Near Wipro</Link>
<Link className="mx-md-2 d-block" to="/Hostel-in-Hinjewadi-Phase-3-for-Male-with-AC-Facilities"><i className="fa fa-bed darkcollor"></i> Hostel in Hinjewadi Phase 3 for Male with AC Facilities</Link>
<Link className="mx-md-2 d-block" to="/PG-in-Laxmi-Chowk-Hinjewadi-Near-Phase-1-and-2"><i className="fa fa-bed darkcollor"></i> PG in Laxmi Chowk Hinjewadi Near Phase 1 & 2</Link>
<Link className="mx-md-2 d-block" to="/Ladies-PG-in-Hinjewadi-Phase-1-Near-Capgemini-and-Infosys"><i className="fa fa-bed darkcollor"></i> Ladies PG in Hinjewadi Phase 1 Near Capgemini & Infosys</Link>
<Link className="mx-md-2 d-block" to="/7-Hills-PG-Hinjewadi"><i className="fa fa-bed darkcollor"></i> 7 Hills PG Hinjewadi</Link>

                    </div>
                  </div>
                </div>       
                {/* Footer Column: Contact */}
                <div className="footer-column col-md-4 col-sm-6 col-xs-12">
                  <div className="footer-widget link-widget">
 
                   

                    <div className="footer-title">
                      <h2>Contact Details</h2>
                      <div className="separator"></div>
                      <div className="logo">
                      <a href="/"><img src={logoSrc} alt={`${brandName} footer logo`} /></a>
                    </div>
                    </div>
                    <div className="widget-content">
                      <ul>
                        <li>
                          <span>Email:</span>{" "}
                          <a href={`mailto:${email}`}>{email}</a>
                        </li>
                        <li>
                          <span>Phone:</span> <a href={`tel:${phone.replace(/\s+/g, "")}`}>{phone}</a>
                        </li>
                        <li>
                          <span>Address:</span> {address}
                        </li>
                      </ul>
                    </div>

                    <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3156.176013955525!2d73.73120287423927!3d18.596449466853958!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDM1JzQ3LjIiTiA3M8KwNDQnMDEuNiJF!5e1!3m2!1sen!2sin!4v1755666696282!5m2!1sen!2sin"  width="300"
          height="220"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                  </div>
                </div>


                {/* /Footer Column */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="column col-md-12 col-sm-12 col-xs-12">
              <div className="copyright">
               <p className="copyright-text">
              All Rights Reserved &copy;  <span className="darkcolorrr">Shree Swami Samarth PG Services</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
              </p>
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </footer>
  );
}
